'use client';

import React, { forwardRef } from 'react';
import clsx from 'clsx';
import omit from 'lodash-es/omit';
import { FEATURE_FLAG_KEYS } from 'shop-ui/constants';
import { ProductCardList, type ProductCardListPropType } from '../ProductCard';
import { useProductGroup } from './useProductGroup';
import STYLE from './ProductGroup.module.scss';

interface ProductGroupPropType extends ProductCardListPropType {}

const productCardDisplayClassMap = {
    scroll: 'scroll',
    grid: 'grid',
} as const;

export const ProductGroup = forwardRef<HTMLDivElement, ProductGroupPropType>(
    (props, ref) => {
        const { isBuyer, styleMap } = props;

        const { productCards, isLoading } = useProductGroup({
            styleMap,
            isBuyer,
        });

        const productCardDisplayType =
            styleMap?.[FEATURE_FLAG_KEYS.PRODUCT_GROUP_CARD_DISPLAY_TYPE];

        return (
            <ProductCardList
                className={clsx(
                    STYLE.root,
                    productCardDisplayType &&
                        productCardDisplayClassMap[productCardDisplayType]
                )}
                style={{
                    '--shop-ui-custom-product-card-list-items': '3.7',
                    ...props.style,
                }}
                {...omit(props, ['style', 'className'])}
                ref={ref}
                onClick={() => {}}
                products={(productCards as Product[]) || []}
                productCardOptions={{
                    useButton: false,
                    usePriceBadge: false,
                    useShadow: false,
                    useSquareImage: false,
                    useProductBadge:
                        !!props.styleMap?.[
                            FEATURE_FLAG_KEYS.PRODUCT_GROUP_USE_PRODUCT_BADGE
                        ],
                    useProductName:
                        !!props.styleMap?.[
                            FEATURE_FLAG_KEYS.PRODUCT_GROUP_USE_PRODUCT_NAME
                        ],
                    useProductPrice:
                        !!props.styleMap?.[
                            FEATURE_FLAG_KEYS.PRODUCT_GROUP_USE_PRODUCT_PRICE
                        ],
                }}
                isLoading={isLoading}
            />
        );
    }
);

ProductGroup.displayName = 'ProductGroup';
